import { useEffect } from 'react'
import Styles from './BottomButtons.module.scss'
import { focusModeSet } from 'redux/actions/focusMode'
import store from 'redux/store'
import { useCurrentArticleId } from 'hooks/useCurrentArticleId'
import { Help } from 'blaze-ui/icons/16'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { HelpDropdown } from 'blaze-components/TopBar/HelpDropdown/HelpDropdown'
import { REACT_APP_DISABLE_TRACKING } from 'env'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { WizardType } from 'components/Wizards/schemas/Types'

export const BottomButtons = ({ videoTutorialType }: { videoTutorialType?: WizardType }) => {
  const currentArticleId = useCurrentArticleId()

  useEffect(() => {
    const onEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        store.dispatch(focusModeSet({ showFocusMode: false, manual: false }))
      }
    }
    document.body.addEventListener('keydown', onEscape)
    return () => document.body.removeEventListener('keydown', onEscape)
  }, [])

  const trigger = (
    <IconButton rounded aria-label="Help" size="lg" useChildClass variant="primary" ignoreHover icon={Help} />
  )

  return (
    <div className={Styles.bottomContainer}>
      <div className={Styles.bottomButtons}>
        {!currentArticleId && (
          <HelpDropdown
            trigger={trigger}
            allowOnboarding={false}
            placement="top-start"
            videoTutorialType={videoTutorialType}
          />
        )}
      </div>
    </div>
  )
}

export const BottomButtonsContainer = () => {
  const { isMobile } = useResponsiveDesign()

  if (REACT_APP_DISABLE_TRACKING) return null

  if (isMobile) {
    return null
  }

  return <BottomButtons />
}
